import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { closeDialog } from '../../../../store/actionCreators/dialog';
import { useDispatch } from 'react-redux';

const UpgradeToCreate =({ clubId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    
    return (
        <React.Fragment>
           <div className={`upgradeText`}>{t('upgradeToCreateText')}</div>
           <div className={`dialogConfirmBox`}>
                <Link className="tertiary" to={`/club/${clubId}/buyLevel`} onClick={()=>dispatch(closeDialog('upgradeClub'))}>{t('button.upgrade')}</Link>
           </div>
        </React.Fragment>
    );
};

export default UpgradeToCreate;